import * as Yup from "yup";
import moment from "moment";
import mentorFormModel from "./mentorFormModel";
const {
  formField: {
    //page1
    email,
    password,
    academicTitle,
    nameEng,
    middleNameEng,
    surnameEng,
    titleNameThai,
    nameThai,
    middleNameThai,
    surnameThai,
    //page2
    faculty,
    department,
    mobileNumber,
    dateOfBirth,
    //page3
    postdocFellowshipRecieve,
    typeAllPostdocs,
    postdocCurrently,
    postdocUnderSupervision,
    resignedPostdoc,
    phdScholarship,
    allPhDStudents,
    phdStudents,
    studentUnderSupervision,
    resignedStudent
  }
} = mentorFormModel;

// const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  Yup.object().shape({
    // [email.name]: Yup.string().email().required(`${email.requiredErrorMsg}`),
    // [password.name]: Yup.string()
    //   .trim()
    //   .required(`${password.requiredErrorMsg}`),
    [academicTitle.name]: Yup.string()
      .trim()
      .required(`${academicTitle.requiredErrorMsg}`),
    [nameEng.name]: Yup.string().trim().required(`${nameEng.requiredErrorMsg}`),
    [surnameEng.name]: Yup.string()
      .trim()
      .required(`${surnameEng.requiredErrorMsg}`),
    [titleNameThai.name]: Yup.string()
      .trim()
      .required(`${titleNameThai.requiredErrorMsg}`),
    [nameThai.name]: Yup.string()
      .trim()
      .required(`${nameThai.requiredErrorMsg}`),
    [surnameThai.name]: Yup.string()
      .trim()
      .required(`${surnameThai.requiredErrorMsg}`)
  }),

  Yup.object().shape({
    [faculty.name]: Yup.string().trim().required(`${faculty.requiredErrorMsg}`),
    [department.name]: Yup.string()
      .trim()
      .required(`${department.requiredErrorMsg}`),
    [mobileNumber.name]: Yup.string()
      .trim()
      .required(`${mobileNumber.requiredErrorMsg}`),
    [dateOfBirth.name]: Yup.string()
      .trim()
      .required(`${dateOfBirth.requiredErrorMsg}`)
  }),

  Yup.object().shape({
    [postdocFellowshipRecieve.name]: Yup.string()
      .trim()
      .required(`${postdocFellowshipRecieve.requiredErrorMsg}`),
    [typeAllPostdocs.name]: Yup.string()
      .trim()
      .required(`${typeAllPostdocs.requiredErrorMsg}`),
    [postdocCurrently.name]: Yup.string()
      .trim()
      .required(`${postdocCurrently.requiredErrorMsg}`),
    [postdocUnderSupervision.name]: Yup.string()
      .trim()
      .required(`${postdocUnderSupervision.requiredErrorMsg}`),
    [resignedPostdoc.name]: Yup.string()
      .trim()
      .required(`${resignedPostdoc.requiredErrorMsg}`),
    [phdScholarship.name]: Yup.string()
      .trim()
      .required(`${phdScholarship.requiredErrorMsg}`),
    [allPhDStudents.name]: Yup.string()
      .trim()
      .required(`${allPhDStudents.requiredErrorMsg}`),
    [phdStudents.name]: Yup.string()
      .trim()
      .required(`${phdStudents.requiredErrorMsg}`),
    [studentUnderSupervision.name]: Yup.string()
      .trim()
      .required(`${studentUnderSupervision.requiredErrorMsg}`),
    [resignedStudent.name]: Yup.string()
      .trim()
      .required(`${resignedStudent.requiredErrorMsg}`)
  })
];
